/** Post-selection coverage preview — quiet annotation lines, no card container. */
export const SAFELISTING_COVERAGE_CALLOUT_CLASS = "flex w-full flex-col gap-1";

/** Rules header inside the date field — only used for loading/warning states now. */
export const SAFELISTING_COVERAGE_RULES_HEADER_CLASS =
  "flex w-full flex-col gap-1";
